import { render, staticRenderFns } from "./SyncOrderStatusConfigDialog.vue?vue&type=template&id=51638664&scoped=true&"
import script from "./SyncOrderStatusConfigDialog.vue?vue&type=script&lang=js&"
export * from "./SyncOrderStatusConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./SyncOrderStatusConfigDialog.vue?vue&type=style&index=0&id=51638664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51638664",
  null
  
)

export default component.exports